import {
  base_colorAction,
  base_colorActionHover,
  base_colorAlert,
  cta_buttonSecondaryBackground,
  grey400,
  grey500,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

const size = spacing(5)

export default css`
  position: relative;
  display: inline-block;

  width: ${size};
  height: ${size};

  input {
    /* Allows for custom styling */
    appearance: none;
    cursor: pointer;

    width: ${size};
    height: ${size};

    /* Border */
    border-radius: ${spacing(1)};
    &:not(:checked, .partial) {
      border: 1px solid ${grey500};
      box-shadow: 0px 1px 3px 0px #00000026;
      &:disabled {
        border: 1px solid ${grey400};
        box-shadow: none;
      }
    }
    &:invalid {
      border: 1px solid ${base_colorAlert};
    }
    &:hover,
    &:focus-visible {
      border-color: ${base_colorActionHover};
    }
    &:focus-visible {
      outline: 2px solid ${base_colorActionHover};
    }

    /* Background */
    background-color: ${cta_buttonSecondaryBackground};
    &:checked,
    &.partial {
      background-color: ${base_colorAction};
      &:hover:not(:disabled),
      &:focus-visible {
        background-color: ${base_colorActionHover};
      }
      &:disabled {
        opacity: 0.4;
      }
    }
  }

  svg {
    position: absolute;
    /* The icon is 4/5 the size, so padding is 1/2 of 1/5 the size */
    top: calc(${size} / 5 / 2);
    left: calc(${size} / 5 / 2);

    width: calc(${size} * 4 / 5);
    height: calc(${size} * 4 / 5);

    pointer-events: none;
  }
  input:not(:checked, .partial) + svg {
    display: none;
  }
`
